import apiClient from '@u/apiClient'
import GetUsageController from '@/wayfinder/actions/App/Http/Controllers/FuneralManager/GetUsageController'
import GetAiUsageController from '@/wayfinder/actions/App/Http/Controllers/Ai/GetAiUsageController'

export default {
  getUsage(_context, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetUsageController.get(), {
          params: payload.params
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getAiUsage(_context, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetAiUsageController.get(), {
          params: payload.params
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
